<template>
    <div class="recap-delivery">
        <v-row>
            <v-col cols="12" md="3">
                <div class="recap deliveries-recap">
                    {{ $t("tours.recap_deliveries") }}
                    <span class="number">{{ in_progress_state }}</span>
                </div>
            </v-col>
            <v-col cols="12" md="3">
                <div class="recap delivered">
                    {{ $t("tours.recap_delivered") }}
                    <span class="number">{{ delivered_state }}</span>
                </div>
            </v-col>
            <v-col cols="12" md="3">
                <div class="recap anomaly-non-blocking">
                    {{ $t("tours.recap_non_blocking_anomaly") }}
                    <span class="number">{{ non_blocking_state }}</span>
                </div>
            </v-col>
            <v-col cols="12" md="3">
                <div class="recap anomaly-blocking">
                    {{ $t("tours.recap_blocking_anomaly") }}
                    <span class="number">{{ blocking_state }}</span>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {
    STEP_IN_PROGRESS_STATE,
    STEP_COMPLETED_STATE,
    STEP_BLOCKING_ANOMALY_STATE,
    STEP_NON_BLOCKING_ANOMALY_STATE,
} from "../../constants";

export default {
    name: "InfosDeliveries",
    props: {
        steps: {
            required: true,
            type: Array,
        },
    },
    computed: {
        in_progress_state() {
            return this.countSteps(STEP_IN_PROGRESS_STATE);
        },
        delivered_state() {
            return this.countSteps(STEP_COMPLETED_STATE);
        },
        non_blocking_state() {
            return this.countSteps(STEP_NON_BLOCKING_ANOMALY_STATE);
        },
        blocking_state() {
            return this.countSteps(STEP_BLOCKING_ANOMALY_STATE);
        },
    },
    methods: {
        countSteps(state) {
            return this.steps.filter((step) => {
                return step.step_state.code === state;
            }).length;
        },
    },
};
</script>
